var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / MapElements / POIS / UKSH / Icons / notaufnahme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-/-MapElements-/-POIS-/-UKSH-/-Icons-/-notaufnahme",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.394736, 0.395129)",
    fill: "#E30621"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1056561,0 C21.8951242,0 28.2105273,6.31461817 28.2105273,14.1048712 C28.2105273,21.8951242 21.8951242,28.2097423 14.1056561,28.2097423 C6.31540309,28.2097423 5.32907052e-14,21.8951242 5.32907052e-14,14.1048712 C5.32907052e-14,6.31461817 6.31540309,0 14.1056561,0 Z M16.5335138,3.69693385 L11.67761,3.69693385 C10.805024,3.69693385 10.0980056,4.40395225 10.0980056,5.27653825 L10.0980056,5.27653825 L10.0980056,10.1093223 L5.26522165,10.1093223 C4.41650125,10.1093223 3.70948285,10.8163407 3.70948285,11.6650611 L3.70948285,11.6650611 L3.70948285,16.5448305 C3.70948285,17.3935509 4.41650125,18.1005693 5.26522165,18.1005693 L5.26522165,18.1005693 L10.0980056,18.1005693 L10.0980056,22.9333533 C10.0980056,23.8051935 10.805024,24.5129577 11.67761,24.5129577 L11.67761,24.5129577 L16.5335138,24.5129577 C17.4060998,24.5129577 18.1131182,23.8051935 18.1131182,22.9333533 L18.1131182,22.9333533 L18.1131182,18.1005693 L22.9459022,18.1005693 C23.7946226,18.1005693 24.501641,17.3935509 24.501641,16.5448305 L24.501641,16.5448305 L24.501641,11.6650611 C24.501641,10.8163407 23.7946226,10.1093223 22.9459022,10.1093223 L22.9459022,10.1093223 L18.1131182,10.1093223 L18.1131182,5.27653825 C18.1131182,4.40395225 17.4060998,3.69693385 16.5335138,3.69693385 L16.5335138,3.69693385 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.a070e77d1c5c6009afe390e1631e05fe.svg";
export { ForwardRef as ReactComponent };